import { useLocation, useParams } from "react-router-dom";
import { useCurrentURLType } from "./useCurrentUrlType";

const useCurrentURL = (): useCurrentURLType => {
    const location = useLocation();
    const params = useParams();

    let split = '/';

    const path = location.pathname.split(split);

    const setIdFromPath = path[2] ?? '';
    const setCommandFromPath = path[3] ?? '';

    return {
      pathname: location.pathname,
      search: location.search,
      params: params,
      pageId: setIdFromPath,
      pageCommand: setCommandFromPath,
    };
};

export {useCurrentURL};
